import { handleResponse, authorizedFetch } from "./requestBuilder.js";

const API_BASE = process.env.REACT_APP_API_URL + "/api/auctions";

export const createAuction = async (formData) => {
  try {
    return await authorizedFetch(`${API_BASE}/create`, {
      method: "POST",
      body: formData,
    });
  } catch (error) {
    console.error("Auction creation error:", error);
    throw error;
  }
};

export const deleteAttachment = async (formData) => {
  try {
    return await authorizedFetch(`${API_BASE}/delete_attachment`, {
      method: "POST",
      body: formData,
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("File deletion error:", error);
    throw error;
  }
};

export const updateAuction = async (formData) => {
  try {
    return await authorizedFetch(`${API_BASE}/update`, {
      method: "PUT",
      body: formData,
    });
  } catch (error) {
    console.error("Auction update error:", error);
    throw error;
  }
};

export const getAuctions = async () => {
  try {
    return await authorizedFetch(API_BASE, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching auctions:", error);
    throw error;
  }
};

export const getAuctionById = async (auctionId) => {
  try {
    return await authorizedFetch(`${API_BASE}/${auctionId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching auction by ID:", error);
    throw error;
  }
};

export const viewAuctionById = async (auctionId) => {
  try {
    const res = await fetch(`${API_BASE}/${auctionId}`, {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" }, // no auth header here
    });
    return handleResponse(res);
  } catch (error) {
    console.error("Error fetching auction by ID:", error);
    throw error;
  }
};

export const getMyAuctions = async () => {
  try {
    return await authorizedFetch(`${API_BASE}/my`, {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching auctions:", error);
    throw error;
  }
};

export const deleteAuctionById = async (auctionId) => {
  try {
    return await authorizedFetch(`${API_BASE}/delete/${auctionId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error deleting auction:", error);
    throw error;
  }
};

const putAuctionAction = async (action, auctionId) => {
  try {
    return await authorizedFetch(`${API_BASE}/${action}/${auctionId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error(`Error on auction action "${action}":`, error);
    throw error;
  }
};

export const initPublishAuction = (auctionId) =>
  putAuctionAction("init_publish", auctionId);
export const publishAuctionAdmin = (auctionId) =>
  putAuctionAction("publish_admin", auctionId);

export const draftAuction = (auctionId) => putAuctionAction("draft", auctionId);

export const extendAuction = (auctionId) =>
  putAuctionAction("extend", auctionId);

export const getAuctionResults = async (auctionId) => {
  try {
    return await authorizedFetch(`${API_BASE}/results/${auctionId}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching auction results:", error);
    throw error;
  }
};

export const confirmWinner = async (auctionId, winnerId) => {
  try {
    return await authorizedFetch(`${API_BASE}/confirm_winner/`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ auctionId, winnerId }),
    });
  } catch (error) {
    console.error("Error confirming auction winner:", error);
    throw error;
  }
};
